import { GatewayApiClient } from '@evidentid/gateway-api-client';

import { createModuleBuilder } from '../../app';
import { createPersistingErrorModule } from '../persisting-error';

export function createRbacModule() {
    return createModuleBuilder()
        .demand<ReturnType<typeof createPersistingErrorModule>>()
        .demandContext<{
        gatewayClient: GatewayApiClient;
    }>()
        .end();
}

export type RbacModule = ReturnType<typeof createRbacModule>;
